import MainLayout from 'layouts/MainLayout';

import AgentDetailPage from 'pages/Agents/Detail';
import AgentEditPage from 'pages/Agents/Edit';
import AgentCreatePage from 'pages/Agents/Create';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/:agentId',
        element: AgentDetailPage,
        exact: true,
        analytics: { name: ["Agente"] },
    }, {
        path: '/agents/create',
        element: AgentCreatePage,
        exact: true,
        analytics: { name: ["Agente", "Creazione"] },
    }, {
        path: '/agents/:agentId/edit',
        element: AgentEditPage,
        exact: true,
        analytics: { name: ["Agente", "Modifica"] },
    }]
}]

export default routes;